<template>
    <div class="calendar">
        <!-- 切换条 -->
        <div class="calendar-tools dsp-flex">
            <div class="calendar-prev" @click="prev">
                <i class="iconfont icon-xiangzuo"></i>
                <span class="text">上一年</span>
            </div>
            <div class="calendar-info" @click.stop="changeYear">
                <div class="year">
                    <span>{{calendarYear}}</span>
                    <i class="iconfont icon-down"></i>
                </div>
            </div>
            <div class="calendar-next"  @click="next">
                <span class="text">下一年</span>
                <i class="iconfont icon-xiangyou"></i>
            </div>
        </div>
        <!-- 日历表 -->
        <div class="calendar-jie-qi clearfix">
            <div class="calendar-jie-qi-item" 
                v-for="cldData in calendarJieQiList"
                v-bind:key="cldData.msg"
                v-bind:class="{'calendar-jie-qi-item-cur':cldData.msg == calendarInfo.yGZ}">
                <span class="calendar-word-bg">{{cldData.zhi}}</span>
                <div class="calendar-word-one" v-bind:class="{'colume-item-gray': parseInt(settingConfigData.showColor) == 0}">
                    <span class="calendar-title" v-bind:class="'wd-' + cldData.g">{{cldData.gan}}</span>
                    <div class="calendar-discribe">
                        <p class="title">{{cldData.jieqi1.title}}</p>
                        <p>{{cldData.jieqi1.timeStr}}</p>
                    </div>
                </div>
                <div class="calendar-word-two" v-bind:class="{'colume-item-gray': parseInt(settingConfigData.showColor) == 0}">
                    <span class="calendar-title" v-bind:class="'wd-' + cldData.z">{{cldData.zhi}}</span>
                    <div class="calendar-discribe">
                        <p class="title">{{cldData.jieqi2.title}}</p>
                        <p>{{cldData.jieqi2.timeStr}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CalendarJieQi',
    components: {},
    computed: {
        calendarJieQiList() {
            return this.$store.state.calendar.calendarJieQiList;
        },
        calendarYear() {
            return this.$store.state.calendar.calendarYear;
        },
        calendarInfo() {
            return this.$store.state.calendar.calendarInfo;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    mounted() {
        this.init();
        this.$bus.on('selectJieQiToday', this.init);
    },
    destroyed() {
        this.$bus.off('selectJieQiToday', this.init);
    },
    methods: {
        init() {
            this.$store.dispatch('calendar/initCalendarJieQi', this.calendarYear)
        },
        prev() {
            this.$store.state.calendar.calendarYear = this.$store.state.calendar.calendarYear - 1;
            this.$store.dispatch('calendar/initCalendarJieQi', this.calendarYear)
        },
        next() {
            this.$store.state.calendar.calendarYear = this.$store.state.calendar.calendarYear + 1;
            this.$store.dispatch('calendar/initCalendarJieQi', this.calendarYear)
        },
        changeYear() {
            this.$store.dispatch('calendar/initCalendarYearPop');
        }
    }
}
</script>